
<h2 mat-dialog-title>
  Play Octopus Terms of Service
</h2>
<mat-dialog-content>
  <div class="access-info-text mb-4 terms-wrapper tos-info">
    <p class="text-center bold-text">
      <b>OCTOPUS TERMS OF SERVICE</b>
    </p>
    <br />
    <p>
      These Octopus Terms of Service (the "Terms") govern the relationship between Octopus
      Interactive, Inc. ("Octopus"), and the individual or entity that registers an account as a driver (a "Driver")
      on the Platform (defined below), and constitute a legally binding agreement between Octopus and Driver.
      Driver wishes to receive from Octopus certain Equipment and to use the Platform in Driver's vehicle to
      engage Riders with trivia, games, and other content and advertisements via the Platform.
    </p>
    <br />
    <p>
      THESE TERMS REQUIRE THE USE OF ARBITRATION TO RESOLVE DISPUTES,
      RATHER THAN JURY TRIALS.
    </p>
    <br />
    <p>
      BY ACCESSING THE PLATFORM OR APPLICATION ("APP"), DRIVER (1) HAS
      READ, UNDERSTOOD, AND AGREES TO BE BOUND BY THESE TERMS AND THE PRIVACY
      POLICY (<a href="https://www.t-mobile.com/privacy-center/privacy-notices/t-mobile-privacy-notice.html" target="_blank" rel="noopener">HTTPS://WWW.T-MOBILE.COM/PRIVACY-CENTER/PRIVACY-NOTICES/TMOBILE-PRIVACY-NOTICE.HTML</a>), (2) REPRESENTS THAT
      DRIVER IS LAWFULLY ABLE
      TO ENTER INTO CONTRACTS (E.G., IF DRIVER IS AN ENTITY, THE INDIVIDUAL
      AGREEING TO THESE TERMS HAS THE AUTHORITY TO DO SO ON BEHALF OF THE
      ENTITY, IF DRIVER IS AN INDIVIDUAL, DRIVER IS NOT A MINOR), AND (3)
      ACKNOWLEDGES THAT DRIVER HAS READ, UNDERSTOOD, AND AGREES TO BE
      BOUND BY THE FOREGOING PROVISIONS, AND THAT ALL REPRESENTATIONS MADE
      BELOW ARE ACCURATE, AND (4) REPRESENTS THAT DRIVER'S PARTICIPATION ON
      THE PLATFORM AND ACCEPTANCE OF THESE TERMS ARE COMPLETELY
      VOLUNTARY.
    </p>
    <br />
    <ol type="1">
      <li>
        <p>
          UPDATES OR CHANGES TO THESE TERMS. Octopus may update these Terms from time to time
          and will provide notice to Driver via the process set forth in Section 11.6(a). By continuing to access or use
          the Equipment or Platform after the effective date of any such change, Driver agrees to any updates to these
          Terms. Updates will be effective upon the effective date indicated at the top of these Terms.
        </p>
      </li>
      <br />
      <li>
        <p>DEFINITIONS.</p>
          <ol type="1" class="definitions-subsections numbered-subsections" data-section-prefix="2">
          <li>
            “<b>Access</b>” means the ability to, physically or logically,
            obtain, read, copy, process, edit, divert, alter the
            state of, or otherwise view data.
          </li>
          <li>
            “<b>Driver Account</b>” means Driver’s account, accessed via
            the online dashboard accessible via mobile application
            or website.
          </li>
          <li>
            “<b>Driver Account Information</b>” means information about
            Driver that Driver provides in connection with the
            creation or administration of Driver’s Account. Driver
            Account Information includes, but is not limited to,
            names, usernames, phone numbers, email addresses, and
            bank account information.
          </li>
          <li>
            “<b>Equipment</b>” means each individual tablet, display
            unit/screen, tablet mount, and certain other
            accessories.
          </li>
          <li>
            “<b>Personal Data</b>” means any data (a) that is reasonably
            capable of being associated with, or could reasonably be
            linked, directly or indirectly, with an identified or
            identifiable individual, household, or device, (b) that
            is ‘personal information’, ‘personal data’, or analogous
            variations of such terms under applicable law related to
            privacy, data security, or protection of information
            about individuals, or (c) linked to, associated with, or
            combined with, information identified in subsections (a)
            or (b), including, identification numbers, location
            data, online identifier, any one or more factors
            specific to a person’s physical, physiological, genetic,
            mental, economic, cultural, national or social identity,
            a person’s name, signature, address, telephone number,
            email address, employee identification number, Social
            Security number, driver’s license number, other
            government-issued identification number, financial
            information (including account numbers, credit or debit
            card number, credit report information, income
            information, password, PIN, account credentials),
            biometric data, medical or health data, answers to
            security questions, or any other personal or account
            authentication information.
          </li>
          <li>
            “<b>Platform</b>” means Octopus’ digital platform that provides
            content and delivers advertisements in an out-of-home
            environment on digital tablets inside rideshare vehicles
            such as Uber and Lyft. For clarity, the Platform does
            not include the Driver Account.
          </li>
          <li>
            “<b>Reward</b>” means any incentive provided by Octopus to
            Driver in relation to the Platform.
          </li>
          <li>
            “<b>Rider</b>” means the passengers in Driver’s vehicle
            interacting with the Platform.
          </li>
          <li>
            “<b>Rideshare</b>” means carrying passengers in Driver’s
            vehicle in connection with a transportation network
            company, such as Uber or Lyft.
          </li>
          <li>
            “<b>Ride Threshold</b>” means one hundred (100) unique rides
            per month.
          </li>
          <li>
            “<b>Security Deposit</b>” means a deposit equal to Two Hundred
            Dollars and Zero Cents ($200.00) to secure the
            Equipment.
          </li>
        </ol>
      </li>
      <br />
      <li>
        <p>DRIVER RESPONSIBILITIES.</p>
        <ol type="1" class="numbered-subsections" data-section-prefix="3">
          <li>
            Account and Messaging.
            <ol type="a">
              <li>
                Driver is an independent provider of Rideshare services, authorized to conduct such
                services in the geographic location(s) in which Driver operates.
              </li>
              <li>
                Driver will only create one Driver Account per email address. Driver is responsible for all
                activities that occur under its Driver Account. Driver acknowledges that when engaging with the Platform
                on a mobile device, data usage rates may apply.
              </li>
              <li>
                To prevent unauthorized access to the Driver Account and to prevent unauthorized use of
                Personal Data and the Platform, Driver agrees to protect and keep confidential all Personal Data (e.g.,
                email,
                phone number, password, and/or other means of accessing the Driver Account via the Platform) by
                implementing appropriate technical measures. Driver acknowledges that unauthorized use of the Driver
                Account could lead to financial loss suffered by Octopus and unauthorized access to Driver's sensitive
                personal and Driver Account Information. If Driver discloses (or otherwise allows to be made known)
                Driver Account Information, user ID, password, or other means of accessing the Driver Account to any
                person or entity, Driver assumes all risks and losses associated with such disclosure. Octopus and its
                affiliates are not responsible for unauthorized access to the Driver Account. If Driver believes someone
                may attempt to use, or has attempted or accessed, the Driver Account without Driver's permission, or that
                any other unauthorized use or security breach has occurred, Driver agrees to immediately notify Octopus
                as set forth in Section 12.6(a) of these Terms.
              </li>
              <li>
                Driver will not use or attempt to use the Platform or any of the other Equipment to access
                any Personal Data other than Driver's own Personal Data. If Driver Accesses any Personal Data other than
                Driver's own Personal Data, Driver will: (i) stop using the Platform and other Equipment immediately; (ii)
                immediately report the Access of Personal Data to Octopus as set forth in Section 12.6(a); and (iii) not
                keep, copy, use, or disclose the Personal Data.
              </li>
            </ol>
          </li>
          <li>
            Communications.
            <ol type="a">
              <li>
                Driver expressly agrees (i) to accept and receive communications sent by or on behalf of
                Octopus, including communications via email, SMS/text message, and direct message to the contact
                information that Driver provides in connection with Driver's relationship or interaction with Octopus,
                including but not limited to Driver's phone or device. Message and data rates may apply and message
                frequency may vary. If there are changes to Driver's contact information (e.g., email address, phone
                number, etc.), Driver agrees to update the Driver Account to help prevent or limit Octopus inadvertently
                communicating with someone else. Carriers are not liable for delayed or undelivered communications.
              </li>
              <li>
                The opt-out options for communications are set out below. If Driver opts-out of receiving
                communications via one channel (e.g., email, SMS/Text message, etc.), then that opt-out will only apply to
                the specific channel for which the opt-out is submitted (e.g., if Driver opts-out of receiving email
                communications, it will not apply to SMS/text messages that Octopus may send). Please see the following
                for more information:
                <ol type="i">
                  <li>
                    For email communications that permit an opt-out (e.g., commercial or marketing
                    messages), there is an opt-out mechanism in the messages.
                  </li>
                  <li>
                    For SMS/text messages, Driver can opt-out of receiving all non-transactional
                    SMS/text messages (e.g., commercial/marketing messages) from Octopus by replying "STOP" to a
                    message. If Driver opts-out, Octopus may send a one-time SMS/text message confirming the opt-out.
                  </li>
                  <li>
                    Driver cannot opt-out of transactional and relationship SMS/text messages or
                    email communications (e.g., messages about security, responses to communications initiated by Driver,
                    Rewards, updates to policies/legal agreements (e.g., privacy policies, terms of service). If Driver
                    does not
                    want to receive this type of SMS/text messages or email communications, the only option is to cease
                    participation in the program by terminating the Driver Account and returning the Equipment as set
                    forth in
                    Section 12.6(b) of these Terms.
                  </li>
                </ol>
              </li>
              <li>
                For more information about Octopus' practices, contact information, and opt-out options,
                Driver may review the Privacy Policy published on and available at
                <a href="https://www.t-mobile.com/privacy-center/privacy-notices/t-mobile-privacy-notice.html" target="_blank" rel="noopener">https://www.t-mobile.com/privacy-center/privacy-notices/t-mobile-privacy-notice.html</a>. If the requirements
                in these Terms conflict with the
                Privacy Policy, the requirements described in the Privacy Policy take precedence. If Driver needs help
                regarding Octopus' practices, contact information, and opt-out options, Driver can contact Octopus at
                <a href="mailto:contact@playoctopus.com">contact@playoctopus.com</a> or, for any SMS/text message, can reply "HELP" to any message for help.
              </li>
            </ol>
          </li>
          <li>
            Equipment; Platform.
            <ol type="a">
              <li>
                Octopus will provide the Driver with the Equipment as Octopus deems
                appropriate. Octopus is responsible for all data costs associated with the Equipment.
              </li>
              <li>
                Driver will keep the Equipment charged, secured, viewable to Riders, and broadcasting
                content for at least the Ride Threshold. If Driver does not meet the Ride Threshold, Driver shall return
                the
                Equipment within seven (7) days following the end of the month in which the Ride Threshold is not met,
                according to the instructions provided by Octopus. If the Equipment is not returned within such timeframe,
                Octopus may retain the Security Deposit provided by Driver. All costs of returning Equipment shall be the
                sole responsibility of Driver, unless otherwise specified by Octopus. Driver has the option to pause their
                Driver Account for one or more one-month periods by following the instructions in the Driver Account. If
                the Driver properly pauses their Driver Account, the Equipment return requirement in this Section 3.3(b)
                will not apply.
              </li>
              <li>
                Octopus may require Driver to pay a Security Deposit in order to receive the Equipment.
                Driver will pay the Security Deposit according to the instructions in 12.6(c) of these Terms.
              </li>
              <li>
                Driver is responsible for ensuring that the Equipment is not lost, damaged, or stolen. Driver
                will immediately report to Octopus any damage, theft, or other issue arising with the Equipment. Driver is
                prohibited from selling, renting, lending or otherwise making the Equipment available to any third party.
              </li>
              <li>
                Driver will only use the Equipment for purposes of displaying the Platform. If the Driver
                becomes aware that the Platform is exited, Driver shall immediately reopen the Platform or, if the
                Platform
                cannot be reopened, notify Octopus immediately in accordance with Section 12.6(b) of these Terms.
              </li>
              <li>
                Driver will not participate in any other interior rideshare engagement or utilize or make
                available any other interior advertising device while Driver remains in possession of the Equipment.
              </li>
              <li>
                Octopus may request the return of the Equipment at any time. If requested by Octopus,
                Driver will return the Equipment to the Octopus address specified in Section 12.6(a) of these Terms,
                within
                ten (10) days of such request. All costs of returning Equipment shall be the sole responsibility of
                Driver,
                unless otherwise specified by Octopus.
              </li>
              <li>
                If Driver fails to return the Equipment when required, in original working condition, then
                Octopus may either retain the Security Deposit and/or charge the Driver Account for lost Equipment as
                follows: (i) tablet ($160.00); (ii) tablet mount ($20.00); (iii) charging cable ($10.00); and (iv)
                charging port
                ($10.00). If any Equipment is stolen and Driver provides Octopus with a complete police report within
                thirty (30) days of the incident, Octopus will waive all charges for such Equipment.
              </li>
              <li>
                Octopus reserves the right to display any content it deems appropriate on the Platform at
                any time.
              </li>
            </ol>
          </li>
          <li>
            Legal Compliance.
            <ol type="a">
              <li>
                Driver will pay all local, state, and federal taxes, fees, and surcharges due in connection
                with any Rewards paid by Octopus to Driver. If applicable laws require Octopus to withhold any taxes from
                any payments made to Driver, Octopus may withhold such taxes and pay the full amount withheld to the
                relevant taxing authority. Any such tax required to be withheld will be an expense of and borne by Driver
                and any amounts paid, deducted, or withheld by Octopus will be treated for all purposes of this Agreement
                as paid to Driver.
              </li>
              <li>
                Driver will maintain adequate insurance in full force and effect with respect to Driver's
                vehicle, during the term of these Terms.
              </li>
              <li>
                Driver is solely responsible for ensuring that any vehicle it uses in connection with the
                Platform conforms to all vehicle laws pertaining to registration, safety, equipment, inspections, and
                operational capacity. Driver shall follow all applicable traffic laws and will direct Riders to abide with
                applicable traffic laws, including seatbelt laws.
              </li>
              <li>
                Driver has and will maintain all licenses and permits necessary to operate the Rideshare,
                including but not limited to a current, active drivers license.
              </li>
              <li>
                Driver is responsible for costs and expenses related to operation of Driver's vehicle,
                including vehicle maintenance, gas, traffic fines or penalties, parking fees, mobile device costs or fees.
              </li>
              <li>
                Driver agrees to maintain all city and state licenses and permits necessary to display
                advertisements in Driver's vehicle.
              </li>
              <li>
                Except as otherwise prohibited by law, Driver assumes all risk of damage or loss to Driver's
                vehicle.
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li>
        REWARDS.
        <ol type="1" class="numbered-subsections" data-section-prefix="4">
          <li>
            Driver may earn Rewards in connection with use of the Platform, published and available at
            <a href="https://playoctopus.com/help/points-calculation/" target="_blank" rel="noopener">https://playoctopus.com/help/points-calculation/</a>. Octopus may make Rewards available to Driver as further
            described in the Driver Account, but any Rewards shall be granted at the sole discretion of Octopus and
            may be updated, changed, or discontinued at any time. Octopus, or its affiliate Play Octopus, LLC on its
            behalf, will make the Rewards available to Driver by sending the Rewards amount to the Driver Account,
            or at a cadence and using a method as otherwise determined by Octopus. Driver can transfer the Rewards
            amount to a bank account or gift card by selecting "Cash Out" from the Driver Account.
          </li>
          <li>
            Subject to Section 3.3 and Section 11, upon termination of these Terms or the Driver Account, any
            unredeemed Rewards shall be made available to Driver if Driver has achieved the Ride Threshold for the
            duration of the Term (unless the Driver has paused the Driver Account as set forth in Section 3.3(b) above),
            provided these unredeemed awards will not be provided until Octopus has received the Equipment from
            the Driver.
          </li>
        </ol>
      </li>
      <li>
        INTELLECTUAL PROPERTY; DATA.
        <ol type="1" class="numbered-subsections" data-section-prefix="5">
          <li>
            <b>Equipment.</b> Octopus hereby grants Driver a non-exclusive, non-transferable, non-sublicensable,
            revocable license to use the Equipment solely for Driver's lawful use in accordance with these Terms. Any
            such license shall terminate upon termination of these Terms or the Driver Account.
          </li>
          <li>
            <b>Ownership.</b> Driver acknowledges and agrees that Octopus owns all right, title, and interest in the
            Platform, resulting data and information, trademarks and other intellectual property, any software,
            technology, or tools used in connection therewith, and any improvements or derivative works thereof
            (collectively, the "Octopus IP"). Driver shall not rent, lease, sublicense, distribute, transfer, copy,
            reproduce, download, display, or modify the Octopus IP or any portion thereof, except with the explicit
            written permission of Octopus. Driver shall not prepare any derivative work based on the Octopus IP and
            shall not translate, reverse engineer, decompile or disassemble the Octopus IP.
          </li>
          <li>
            <b>Data Collection and Use.</b> Octopus may collect certain data from the Equipment located in Driver's
            vehicle including, without limitation, latitude-longitude coordinates for geographic location. Octopus may
            collect data based on driving records that Driver shares with Octopus, Driver and Rider interactions with
            the Equipment, location-based data from the Equipment, as well as other methods and data. Octopus may
            share some, all, or none of this information with advertisers as part of the advertising sales process or
            other
            third parties in Octopus' sole discretion. Octopus' collection and use of Driver's Personal Data will be
            governed by the Privacy Policy published on and available at
            <a href="https://www.t-mobile.com/privacy-center/privacy-notices/t-mobile-privacy-notice.html" target="_blank" rel="noopener">https://www.t-mobile.com/privacy-center/privacy-notices/t-mobile-privacy-notice.html</a>.
          </li>
          <li>
            <b>Feedback.</b> As between Octopus and Driver, any suggestions, feedback, ideas, or content Driver
            discloses concerning the Platform or Equipment, including all intellectual property and other rights therein
            or related thereto (collectively, "Feedback"), shall be owned exclusively by Octopus and considered
            Octopus' Confidential Information (defined below). Driver hereby assigns all right, title, and interest in and
            to any Feedback to Octopus, and agrees that Octopus may use and exploit such Feedback in any manner
            and medium in perpetuity without attribution, obligation, or compensation to Driver. Driver will take all
            actions required by Octopus to register, protect, and enforce Octopus' rights in Feedback. Except as
            expressly stated herein, nothing in these Terms grants either party any rights to the other party's content or
            intellectual property.
          </li>
        </ol>
      </li>
      <li>
        CONFIDENTIALITY. Driver will keep strictly confidential the Confidential Information disclosed
        by Octopus. This obligation will continue until five (5) years after these Terms terminate, except that the
        obligations under this Section 5 will apply indefinitely to trade secret information and Personal Data.
        Confidential information includes, but is not limited to: (i) all information Driver receives or derives from
        or pursuant to, or in relation to, utilizing the Platform; (ii) Rewards; (iii) these Terms; and (iv) information
        relating to T-Mobile's customers, technology, business affairs, and marketing or sales plans (collectively the
        "Confidential Information"). Driver will use Confidential Information only for the purpose of performing
        under these Terms, and will not disclose any Confidential Information Driver receives in connection with
        these Terms to any third party, other than its legal, tax, and accounting advisors who are bound by a duty
        of confidentiality or as required by applicable laws.
      </li>
      <li>
        TERM AND TERMINATION.
        <ol type="1" class="numbered-subsections" data-section-prefix="7">
          <li>
            <b>Term.</b> Except as terminated as set forth below, these Terms are effective as of the date the Driver
            activates a Driver Account, and will continue for a period of one (1) year, after which these Terms will
            automatically renew for successive one (1)-year periods.
          </li>
          <li>
            <b>Termination.</b> Octopus may terminate these Terms immediately upon a breach by Driver of any
            provision of these Terms; or without cause upon not less than two (2) days' prior written notice to Driver.
            Driver may terminate the Driver Account with Octopus upon ten (10) days' notice to Octopus and the return
            of the Equipment to Octopus, upon which time these Terms will terminate. Termination, regardless of cause or
            nature, will be without prejudice to any other rights or remedies of the parties and will be without liability
            for any loss or damage caused by such termination.
          </li>
          <li>
            <b>Post-Termination; Survival.</b> Upon termination of these Terms, the rights and licenses granted to
            Driver will immediately terminate, and Octopus will deactivate the Driver Account; Octopus will delete
            the Driver Account only upon Driver's written request. All sections of these Terms that by their nature
            should survive termination will survive, including, without limitation, amounts due for unreturned
            Equipment, indemnification obligations, confidentiality obligations, warranty disclaimers, and limitations
            of liability.
          </li>
        </ol>
      </li>
      <li>
        REPRESENTATIONS AND WARRANTIES.
        <ol type="1" class="numbered-subsections" data-section-prefix="8">
          <li>
            <b>Representations and Warranties.</b> Driver represents and warrants that: (i) Driver is an independent
            provider of the services it provides to Riders, and is authorized to conduct such services in the geographic
            location(s) in which Driver operates; (ii) Driver has the right, power, and authority to agree to these Terms;
            and (iii) the information shared by Driver, including Driver's profile displayed on the Platform, does not
            and will not violate any copyright, trademark, or other intellectual property right or right of privacy or
            publicity of any third party, and will not violate any terms or policies of the Rideshare company(s) for
            which Driver drives.
          </li>
          <li>
            <b>Warranty Disclaimer.</b> THE PLATFORM, THE EQUIPMENT AND ANY THIRD-PARTY
            SOFTWARE, IS LICENSED AND MADE AVAIALBLE TO DRIVER "AS-IS." DRIVER BEARS ALL
            RISK OF USING THE PLATFORM AND THE EQUIPMENT. OCTOPUS DISCLAIMS ALL
            WARRANTIES, WHETHER STATUTORY, EXPRESS OR IMPLIED, COURSE OF DEALING,
            COURSE OF PERFORMANCE, USAGE OF TRADE, OR OTHERWISE, WITH RESPECT TO THE
            PLATFORM AND EQUIPMENT, AND DRIVER'S USE THEREOF, INCLUDING THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NONINFRINGEMENT. OCTOPUS DOES NOT WARRANT
            OR GUARANTEE THAT THE PLATFORM
            OR EQUIPMENT SHALL BE UNINTERRUPTED OR ERROR-FREE.
          </li>
        </ol>
      </li>
      <li>
        INDEMNIFICATION. Driver agrees to defend, indemnify, and hold Octopus, its affiliates and related
        entities, and any of their officers, directors, agents and employees, harmless from and against any and all
        claims, lawsuits, actions, investigations, or proceedings (and all related liability, loss, penalties, damages,
        or expenses, including attorney's fees and costs) arising from or relating to any of the following: (i) the
        actions or omissions of Driver in connection with these Terms, including personal injury or death to any
        person (including to Driver); (ii) Driver's use of the Platform and the Equipment; (ii) any breach or alleged
        breach by Driver of these Terms; (iii) any violation by Driver of applicable laws, rules, or regulations; or
        (iv) any claim arising out of or relating to the information and services provided by Driver including, but
        not limited to, any claims for false advertising, product defects, personal injury, death, or property damages.
        Driver's obligations include the cost of defense, including attorneys' fees, as well as the payment of any
        final judgment rendered against or settlement agreed upon by Octopus or its affiliated companies.
      </li>
      <li>
        LIMITATION OF LIABILITY. OCTOPUS AND ITS AFFILIATES SHALL NOT BE LIABLE
        UNDER THESE TERMS FOR ANY OF THE FOLLOWING, WHETHER BASED ON CONTRACT,
        TORT OR ANY OTHER LEGAL THEORY, EVEN IF OCTOPUS HAS BEEN ADVISED OF THE
        POSSIBILITY OF SUCH DAMAGES: ANY INCIDENTAL, COMPENSATORY, GENERAL,
        PUNITIVE OR ENHANCED, SPECIAL, EXEMPLARY, CONSEQUENTIAL, DRIVER'S PROPERTY
        DAMAGE, BODILY INJURY, OR LOSS OR INACCURACY OF DATA, LOSS OF BUSINESS,
        REVENUE, PROFITS, USE OR OTHER ECONOMIC ADVANTAGE, OR OTHER INDIRECT
        DAMAGES OF ANY TYPE OR KIND. EXCEPT AS PROHIBITED BY LAW, OCTOPUS'
        CUMULATIVE LIABILITY HEREUNDER SHALL NOT EXCEED THE LESSER OF (A) THE
        SECURITY DEPOSIT AND (B) TWO HUNDRED DOLLARS AND ZERO CENTS ($200.00).
      </li>
      <li>
        LEGAL PROCESS.
        <ol type="1" class="numbered-subsections" data-section-prefix="11">
          <li>
            If legal action such as a garnishment, levy, or other state, provincial, or federal legal process
            ("Legal Process") is brought against the Driver or Driver Account, Octopus will not contest on Driver's
            behalf any such Legal Process and may take action to comply with such Legal Process as Octopus
            determines to be appropriate. Driver agrees that Octopus may honor Legal Process that is served personally,
            by mail, email, or facsimile transmission at any Octopus facility or at the office of any agent authorized by
            appointment or by law to receive service on behalf of Octopus, even if such service is insufficient under
            applicable law.
          </li>
          <li>
            If Legal Process is brought against the Driver or Driver Account, Octopus may prohibit Driver
            from receiving Rewards and Octopus shall not be liable to Driver on account of any losses resulting from
            such prohibition.
          </li>
        </ol>
      </li>
      <li>
        MISCELLANEOUS.
        <ol type="1" class="numbered-subsections" data-section-prefix="12">
          <li>
            <b>Independent Drivers; Nonexclusive Relationship.</b> Octopus and Driver are independent
            contractors, and these Terms will not be construed to create any partnership, joint venture, agency, or
            employment relationship between Octopus and Driver. Neither party has the authority to bind the other
            party or assume or create any obligation or liability on the other party's behalf.
          </li>
          <li>
            <b>No Third-Party Beneficiaries.</b> These Terms are for the sole benefit of the parties hereto and
            nothing herein express or implied shall give or be construed to give any person or entity other than the
            parties hereto any legal or equitable rights hereunder.
          </li>
          <li>
            <b>Assignment.</b> Driver will not assign or otherwise transfer these Terms or any of its rights and
            obligations under these Terms without Octopus' prior written consent. Subject to the foregoing, these Terms
            will be binding upon, and inure to the benefit of, the parties and their respective permitted successors and
            assigns.
          </li>
          <li>
            <b>Force Majeure.</b> Octopus and its affiliates will not be liable for any delay or failure to perform any
            obligation under these Terms where the delay or failure results from any cause beyond its reasonable
            control, including acts of God, labor disputes or other industrial disturbances, electrical or power outages,
            utilities or other telecommunications failures, earthquake, storms or other elements of nature, blockages,
            embargoes, riots, acts of government, acts of terrorism, or war.
          </li>
          <li>
            <b>Publicity.</b> Driver will not issue any press release or make any other public communication
            regarding Driver's use of the Platform without Octopus' prior written consent.
          </li>
          <li>
            Legal Notices; Addresses.
            <ol type="a">
              <li>
                <b>Legal Notices.</b> All legal notices and requests in connection with these Terms will be
                deemed given as of the day they are received either by email (as to Driver only), delivery service, or in
                the
                mail, at the following addresses:<br /><br />
                <div class="address-sec">
                  <span>
                    <b>To Octopus:</b> &ngsp;&ngsp;
                  </span>
                  <span>
                    Octopus Interactive, Inc.<br />
                    c/o T-Mobile USA, Inc.<br />
                    Attn: Deputy General Counsel<br />
                    12920 SE 38th Street<br />
                    Bellevue, WA 98006<br /><br />
                    With a copy to: contact@playoctopus.com
                  </span>
                </div>
                <div>
                  <b>To Driver:</b> At the email address and phone number registered by Driver with
                  Octopus. Unsubscribing from Octopus' email or SMS communications shall not relieve
                  Driver of Driver's obligations under these Terms and shall void any notice
                  requirements.
                </div>
              </li>
              <li>
                <b>Equipment Return.</b> All Equipment should be returned to the following address:
                <div class="address-sec">
                  <span> &ngsp;&ngsp; </span>
                  <span>
                    Octopus Interactive, Inc.<br />
                    4550 Montgomery Avenue, Suite 110N<br />
                    Bethesda, MD 20814<br /><br />
                  </span>
                </div>
              </li>
              <li>
                <b>Payment.</b> Any amounts owed to Octopus paid by Driver by check should be sent to the
                following address:
                <div class="address-sec">
                  <span> &ngsp;&ngsp; </span>
                  <span>
                    T-Mobile USA, Inc.<br />
                    PO Box 94142<br />
                    Seattle, WA 98124-6442<br /><br />
                  </span>
                </div>
                Make check payable to "T-Mobile USA, Inc." and include in the memo line: "Play Octopus
                Tablet" and your full name.
              </li>
            </ol>
          </li>
          <li>
            <b>No Waiver; Severability.</b> Either party's failure to enforce any provision of these Terms will not
            constitute a waiver of such provision. If any portion of these Terms is held to be invalid or unenforceable,
            the remaining portions of these Terms will remain in full force and effect.
          </li>
          <li>
            <b>Choice of Law; Dispute Resolution.</b> This Agreement will be governed in all respects by, and
            construed and enforced in accordance with, the laws of the State of Washington without regard to any rules
            governing conflicts of laws. Any dispute between Driver and Octopus arising out these Terms shall be
            submitted to the American Arbitration Association (the "AAA") to be resolved through arbitration under
            AAA Commercial Arbitration Rules. The arbitration will occur before a single arbitrator selected pursuant
            to AAA rules, with proceedings to be conducted in Seattle, Washington. Any court proceedings for
            preliminary relief, or relief in aid of arbitration, will be brought in state or federal court in King County,
            Washington. Any award, order, or judgment pursuant to arbitration under this provision will be deemed
            final and binding and may be enforced in any court of competent jurisdiction. Driver and Octopus agree
            that the arbitrator will have no power or authority to make awards or issue orders of any kind that are
            prohibited by these Terms. All arbitration proceedings and negotiations pursuant to this Section 12.8 shall
            be confidential and shall be accorded the same protection accorded for private mediation under Washington
            law. The arbitrator may, as part of the arbitration award, award the substantially prevailing party in the
            arbitration its out-of-pocket costs incurred in connection with the arbitration.
          </li>
        </ol>
      </li>
      <li>
        JURISDICTION-SPECIFIC TERMS. In addition to the Terms above, the following supplemental
        jurisdiction-specific terms apply to Drivers who operate vehicles in the jurisdictions below.
        <ol type="1" class="numbered-subsections" data-section-prefix="13">
          <li>
            <b>City of New York, New York.</b>
            <ol type="a">
              <li>
                <b>Octopus Obligations.</b>
                <ol type="i">
                  <li>
                    Octopus will pay Rewards to the Driver on no less than a weekly basis.
                  </li>
                  <li>
                    Notwithstanding Section 3.3(h) of these Terms, Driver will receive the Security
                    Deposit in full upon return of the Equipment.
                  </li>
                  <li>
                    Notwithstanding Section 7.2 (Termination) of these Terms, Octopus will provide
                    Driver no less than ten (10) days prior written notice of termination.
                  </li>
                </ol>
              </li>
              <li>
                <b>Limitation of Liability.</b> Each party agrees that any limitation of liability in these Terms
                will not apply to any and all damages, fines, penalties, deficiencies, losses, liabilities, and expenses
                (including reasonable attorneys' fees) arising from direct claims between the parties based on damage to
                real or tangible personal property, death, or bodily injury caused by the negligent or willful conduct of
                a
                party.
              </li>
              <li>
                <b>Governing Law; Venue.</b> Notwithstanding Section 12.8 (Choice of Law; Dispute
                Resolution) of these Terms, these Terms are deemed to be executed in the City and State of New York,
                regardless of the domicile of the parties, and is governed by and construed in accordance with the laws of
                the State of New York (notwithstanding New York choice of law or conflict of law principles) and the laws
                of the United States, where applicable. Octopus and the Driver agree that any and all claims asserted by
                or against either party arising under or related to these Terms will be heard and determined either in the
                courts
                of the United States of America located in the City of New York or in the courts of New York State located
                in the City of New York.
              </li>
              <li>
                <b>Access to Terms.</b> Driver may request a copy of these Terms at any time.
              </li>
              <li>
                <b>Electronic Signatures.</b> Electronic signatures are permissible for the Terms and all signed
                electronic Terms will be transmitted electronically to the Driver by Octopus.
              </li>
              <li>
                <b>Retaliation.</b> Octopus is prohibited from retaliating against any Driver for making a good
                faith complaint against Octopus for violation of these Terms or City of New York Title 35 Section 59E-17.
                "Retaliation" will be broadly construed and will include imposing any adverse condition or consequence
                on the Driver or withholding or withdrawing any beneficial condition or consequence from the Driver.
              </li>
            </ol>
          </li>
        </ol>
      </li>
    </ol>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button class="btn btn-pink close-btn" mat-dialog-close id="terms-dialog-close-button">
    Close
  </button>
</mat-dialog-actions>
